import actionTypes from './actions/actionTypes'

const {
  REQUEST_VALIDATION,
  RECEIVE_VALIDATION,
  REQUEST_RESET,
  RECEIVE_RESET,
  LINK_EXPIRED
} = actionTypes

const resetReducer = (
  state = {
    isValidating: false,
    isUpdating: false,
    expired: false,
    resetSuccess: false,
    error: null
  },
  action
) => {
  switch (action.type) {
    case REQUEST_RESET:
      return Object.assign({}, state, {isUpdating: true})
    case RECEIVE_RESET:
      return Object.assign({}, state, {
        isUpdating: false,
        resetSuccess: action.resetSuccess,
        error: action.error
      })
    case REQUEST_VALIDATION:
      return Object.assign({}, state, {isValidating: true})
    case RECEIVE_VALIDATION:
      return Object.assign({}, state, {isValidating: false})
    case LINK_EXPIRED:
      return Object.assign({}, state, {expired: action.expired})
    default:
      return state
  }
}

export default resetReducer



// WEBPACK FOOTER //
// ./src/routes/ResetPassword/reducer.js